import { createAction } from '@reduxjs/toolkit';
import * as itemTypes from '../../../items/item-types';
import {
  getItem as getItemInternal,
  saveItem as saveItemInternal
} from '../../../items/item.actions';
import { keyFromItemType } from '../../../routing-utils';

export const receivePartnerCampaign = createAction('receivePartnerCampaign');
export const setPartnerCampaignIsBusy = createAction(
  'setPartnerCampaignIsBusy'
);
export const modifyPartnerCampaign = createAction('modifyPartnerCampaign');
export const closePartnerCampaign = createAction('closePartnerCampaign');
export const setPartnerCampaignHasValidationError = createAction(
  'setPartnerCampaignHasValidationError'
);

const partnerCampaignModel = (id, name, params) => ({
  id,
  name,
  type: itemTypes.PARTNER_CAMPAIGN,
  description: '',
  tags: [],
  [keyFromItemType(itemTypes.TRAFFIC_PARTNER)]: params.trafficpartnerid
});

export const getItem = getItemInternal(
  partnerCampaignModel,
  receivePartnerCampaign,
  setPartnerCampaignIsBusy
);

export const saveItem = saveItemInternal(modifyPartnerCampaign, item => {
  if (!item.name || !item.name.trim()) {
    return 'Name is required.';
  }
});
